/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './dashboard-manage-dialog.component';
export * from './dashboard-manage-dialog.route';
